/* eslint-disable jsx-a11y/no-autofocus */
import React from 'react';
import { utils } from '@rjsf/core';
import { format, isValid } from 'date-fns';
import { DatePicker } from '../../';
import { CustomWidgetProps } from '../types';

const { utcToLocal, getDisplayLabel } = utils;

const DateWidget: React.FC<React.PropsWithChildren<CustomWidgetProps>> = ({
  id,
  placeholder,
  disabled,
  label,
  readonly: readOnly,
  value,
  onChange,
  schema,
  uiSchema,
  formContext: { onHasChanged },
}: CustomWidgetProps) => {
  const _value = utcToLocal(value);
  const _onHasChanged = (newValue: string, oldValue: string) => {
    const oldDateOnly = isValid(new Date(oldValue)) ? format(new Date(oldValue), 'y-MM-dd') : '';
    const newDateOnly = isValid(new Date(newValue)) ? format(new Date(newValue), 'y-MM-dd') : '';

    if (oldDateOnly !== newDateOnly) onHasChanged?.({ id, value: newValue });
  };
  const _onChange = (value: string) => {
    try {
      if (value) {
        const dateOnly = isValid(new Date(value)) ? format(new Date(value), 'y-MM-dd') : value;
        onChange(dateOnly);
      } else {
        onChange(undefined);
      }
    } catch (e) {
      onChange(undefined);
    }
  };

  const displayLabel = getDisplayLabel(schema, uiSchema);

  return (
    <>
      <DatePicker
        className="date-widget"
        label={displayLabel ? label || schema.title || '' : placeholder || ''}
        value={_value}
        disabled={disabled}
        readOnly={readOnly}
        onChange={(value: string | null) => {
          _onChange(value || '');
          onHasChanged && setTimeout(() => _onHasChanged(value || '', _value), 0);
        }}
        sx={{
          '&.date-widget': {
            border: '1px solid #D5D7DA',
            borderRadius: '8px',
          },
          '&.date-widget.Mui-focused': {
            '& fieldset': {
              borderWidth: 0,
            },
          },
        }}
      />
    </>
  );
};

export default DateWidget;
